(() => {
  'use strict';
  const script = document.currentScript;
  const context = script?.dataset || {};
  const insight = (method, ...values) => {
    if (typeof window.clarity === 'function') window.clarity(method, ...values);
  };
  const params = new URLSearchParams(location.search);
  const campaigns = params.getAll('utm_campaign');
  const invalid = campaigns.some(value => /__CAMPAIGN_NAME__|\{\{[^}]+\}\}/.test(value));
  const tags = {
    theme_id: context.themeId || '',
    theme_name: context.themeName || '',
    cro_release: context.croRelease || '',
    page_type: context.pageType || '',
    page_path: context.pagePath || '',
    utm_quality: invalid ? 'unresolved_placeholder' : campaigns.length ? 'tagged' : 'untagged'
  };
  let sent = false;
  let tries = 0;
  const tagSession = () => {
    if (sent) return;
    if (typeof window.clarity === 'function') {
      Object.entries(tags).forEach(([key, value]) => insight('set', key, value));
      sent = true;
      if (script) script.dataset.clarityTags = 'queued';
    } else if (++tries < 20) {
      setTimeout(tagSession, 500);
    }
  };
  tagSession();
  document.addEventListener('visitorConsentCollected', tagSession);
  const gridFor = element => {
    const slider = element.closest('product-slider');
    const root = slider?.querySelector('[data-slider-options]');
    if (!root) return null;
    try {
      return JSON.parse(root.dataset.sliderOptions).slidertype === 'grid' ? root : null;
    } catch { return null; }
  };
  const selectCollection = (root, handle) => {
    if (!/^[a-z0-9-]+$/.test(handle || '')) return false;
    const swiperElement = root.querySelector('.swiper');
    const wrapper = swiperElement?.querySelector(':scope > .swiper-wrapper');
    if (!wrapper) return false;
    const slides = Array.from(wrapper.children).filter(slide => slide.classList.contains('swiper-slide'));
    const collectionClass = 'collection_' + handle.replace(/-/g, '_');
    if (!slides.some(slide => slide.classList.contains(collectionClass))) return false;
    slides.forEach(slide => {
      const selected = slide.classList.contains(collectionClass);
      slide.style.display = selected ? '' : 'none';
      slide.setAttribute('aria-hidden', String(!selected));
    });
    root.querySelectorAll('[data-collection-handle]').forEach(control => {
      const selected = control.dataset.collectionHandle === handle;
      if (control.matches('button.collection-button')) {
        control.classList.toggle('tab-selected', selected);
        control.classList.toggle('tab-unselected', !selected);
        control.setAttribute('aria-pressed', String(selected));
      } else {
        control.classList.toggle('active', selected);
        if (selected) control.setAttribute('aria-current', 'true');
        else control.removeAttribute('aria-current');
      }
    });
    const selectedControl = root.querySelector('[data-collection-handle="' + handle + '"]');
    root.querySelectorAll('.select-dropdowntoggle').forEach(control => {
      control.textContent = selectedControl?.dataset.collectionTitle || handle;
    });
    if (swiperElement.swiper && !swiperElement.swiper.destroyed) {
      swiperElement.swiper.update();
      swiperElement.swiper.slideTo(0);
    }
    return true;
  };
  document.querySelectorAll('product-slider button.collection-button').forEach(button => {
    button.type = 'button';
    button.setAttribute('aria-pressed', String(button.classList.contains('tab-selected')));
  });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('[data-cro-hero-cta]')) insight('event', 'cro_home_hero_cta_clicked');
    const heroLink = event.target.closest('[data-cro-hero-link]');
    if (heroLink) {
      insight('set', 'hero_destination', heroLink.dataset.croHeroDestination || '');
      insight('event', 'cro_home_hero_link_clicked');
    }
    const control = event.target.closest('[data-collection-handle]');
    if (control && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey && event.button === 0) {
      const root = gridFor(control);
      if (root && selectCollection(root, control.dataset.collectionHandle)) {
        const menu = control.closest('.dropdown-menu');
        const toggle = menu?.parentElement.querySelector('.select-dropdowntoggle');
        if (toggle && window.bootstrap?.Dropdown) window.bootstrap.Dropdown.getInstance(toggle)?.hide();
        event.preventDefault();
        event.stopImmediatePropagation();
        insight('event', 'cro_category_selected');
        return;
      }
    }
    if (event.target.closest('[data-cro-authentic-shop]')) insight('event', 'cro_authenticity_shop_clicked');
    if (event.target.closest('[data-cro-flavor-shortlist]')) insight('event', 'cro_flavor_shortlist_opened');
    if (event.target.closest('[data-cro-coa]')) insight('event', 'cro_lab_report_opened');
    const productLink = event.target.closest('a[href*="/products/"]');
    if (productLink && context.pageType === 'collection') insight('event', 'cro_collection_product_opened');
  }, true);
})();


